import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";
import Swal from 'sweetalert2'
import { Link } from "react-router-dom";
import AddSchoolModal from "./Add/AddSchoolModal";
import AddClassModal from "./Add/AddClassModal";
import AddSessionModal from "./Add/AddSessionModal";
import Select from "react-select";
export default function AddSchoolEnrollment() {

  const [families, setFamilies] = useState([]);
  const [children, setChildren] = useState([]);
  const [cities, setCities] = useState([]);
  const [donors, setDonors] = useState([]);
  const [schools, setSchools] = useState([]);
  const [classes, setClasses] = useState([]);
  const [filteredClasses, setFilteredClasses] = useState([]);

  const [sessions, setSessions] = useState([]);
  const [trainingId, setTrainingId] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [videoUploading, setVideoUploading] = useState(false);
  const [showSchoolModal, setShowSchoolModal] = useState(false);
  const [showClassModal, setShowClassModal] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [newSession, setNewSession] = useState({
    name: "",
    start_date: "",
    end_date: ""
  });
  const [sessionErrors, setSessionErrors] = useState({});


  const [disabled, setDisabled] = useState(false);
  const [schoolErrors, setSchoolErrors] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const [form, setForm] = useState({
    person_id: "",
    student_id: "",
    dob: "",
    admission_date: "",
    school_id: "",
    class_id: "",
    academic_session_id: "",
    roll_no: "",
    status: "",
    remarks: "",
    donor_id: "",
    fee: "",
    cost: "",
    going_image: null,
    student_image: null,
    fee_receipt: null,
    cost_receipt: null,
  });

  const [previews, setPreviews] = useState({
    going_image: null,
    student_image: null,
  });

  const [newSchool, setNewSchool] = useState({
    name: "",
    city_id: "",
    code: "",
    principal_name: "",
    contact_no: "",
    email: "",
    address: "",
    authority: "",
    level: "",
    status: 1,
  });

  const [newClass, setNewClass] = useState("");
  const [classErrors, setClassErrors] = useState({});

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    const res = await axios.get(
      process.env.REACT_APP_API_URL + "/initial-school-enrollments"
    );

    setFamilies(res.data.people || []);
    setDonors(res.data.donors || []);


    setCities(res.data.cities || []);
    setSchools(res.data.schools || []);
    setClasses(res.data.schoolClasses || []);
    setSessions(res.data.accesedSessions || []);

  };
  const familyOptions = families.map((f) => ({
    value: f.person_id,
    label: `${f.f_number} - ${f.beneficiary_name} (${f.city_name})`,
  }));
  const handleFamilyChange = async (e) => {
    const familyId = e.target.value;

    setForm((prev) => ({
      ...prev,
      person_id: familyId,
      student_id: "",
      student_name: "",
      relation: "",
    }));

    const res = await axios.get(
      process.env.REACT_APP_API_URL +
      `/initial-school-enrollments/${familyId}`
    );

    setChildren(res.data.students || []);


  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "school_id") {
      const filtered = classes.filter(
        (item) => item.school_id === Number(value)
      );

      setFilteredClasses(filtered);

      // Optional: reset selected class
      setForm((prev) => ({
        ...prev,
        school_id: value,
        class_id: "",
      }));
    }
  };

  const handleChildChange = (e) => {
    const id = e.target.value;
    const selected = children.find((c) => c.id == id);
    console.log("Selected Child:", id);
    setForm({
      ...form,
      student_id: selected?.id || "",
      dob: selected?.dob || "",

    });
  };

  const handleImageChange = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    if (previews[field]) URL.revokeObjectURL(previews[field]);

    const url = URL.createObjectURL(file);

    setForm((prev) => ({ ...prev, [field]: file }));
    setPreviews((prev) => ({ ...prev, [field]: url }));
  };

  const removeImage = (field) => {
    if (previews[field]) URL.revokeObjectURL(previews[field]);

    setForm((prev) => ({ ...prev, [field]: null }));
    setPreviews((prev) => ({ ...prev, [field]: null }));

    const input = document.getElementById(`input-${field}`);
    if (input) input.value = "";
  };

  const validate = () => {
    const errors = {};

    if (!form.person_id) errors.person_id = "Family is required";
    if (!form.student_id) errors.student_id = "Student is required";
    if (!form.dob) errors.dob = "Student's date of birth is required";
    if (!form.admission_date) errors.admission_date = "admission_date is required";
    if (!form.school_id) errors.school_id = "Institute is required";
    if (!form.class_id) errors.class_id = "Training is required";
    if (!form.academic_session_id) errors.academic_session_id = "Session is required";
    if (!form.roll_no) errors.roll_no = "Roll Number is required";
    if (!form.status) errors.status = "Status is required";
    if (form.fee === "") errors.fee = "Fee is required";
    if (Number(form.fee) > 0 && !form.fee_receipt) {
      errors.fee_receipt = "fee_receipt is required when fee is greater than 0";
    }
    if (Number(form.cost) > 0 && !form.cost_receipt) {
      errors.cost_receipt = "cost_receipt is required when fee is greater than 0";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire({
        title: 'Error!',
        text: 'Please fix the errors in the form.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      return;
    }

    try {
      const data = new FormData();

      Object.keys(form).forEach((key) => {
        if (form[key] !== null && form[key] !== "") {
          data.append(key, form[key]);
        }
      });

      const response = await axios.post(
        process.env.REACT_APP_API_URL +
        "/school-enrollments",
        data,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      setTrainingId(response.data.data.id);
      setForm({
        person_id: "",
        student_id: "",
        dob: "",
        admission_date: "",
        school_id: "",
        class_id: "",
        academic_session_id: "",
        roll_no: "",
        status: "",
        remarks: "",
        donor_id: "",
        fee: "",
        cost: "",
        going_image: null,
        student_image: null,
        fee_receipt: null,
        cost_receipt: null,
      });

      Swal.fire({
        title: 'Success!',
        text: 'Training saved successfully. You can now upload the video.',
        icon: 'success',
        confirmButtonText: 'Ok'

      });

    } catch (error) {
      console.error(error);

      // Laravel validation errors
      if (error.response?.status === 422) {
        const errors = error.response.data.errors;

        // Convert all validation errors into readable text
        const errorMessages = Object.values(errors)
          .flat()
          .join('\n');

        Swal.fire({
          title: 'Validation Error!',
          text: errorMessages,
          icon: 'error',
          confirmButtonText: 'Ok'
        });

        return;
      }

      // Other server/API errors
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message || 'Failed to save training.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    }
  };

  const saveSchool = async () => {
    try {
      setSchoolErrors({});

      const res = await axios.post(
        process.env.REACT_APP_API_URL + "/store-school",
        newSchool
      );

      const created = res.data.data;

      setSchools((prev) => [...prev, created]);
      setForm((prev) => ({
        ...prev,
        school_id: created.id,
      }));

      closeSchoolModal();
    } catch (error) {
      if (error.response?.status === 422) {
        setSchoolErrors(error.response.data.errors);
      } else {
        alert(error.response?.data?.message || "Something went wrong.");
      }
    }
  };

  const closeSchoolModal = () => {
    setNewSchool({
      name: "",
      city_id: "",
      code: "",
      principal_name: "",
      contact_no: "",
      email: "",
      address: "",
      authority: "",
      level: "",
      status: 1,
    });

    setShowSchoolModal(false);
  };

  const closeClaessModal = () => {
    setNewClass("");
    setClassErrors({});
    setShowClassModal(false);
  };


  const saveClass = async () => {
    if (!form.school_id) {
      setClassErrors({
        school_id: ["Please select a school first."],
      });
      return;
    }

    try {
      setClassErrors({});

      const res = await axios.post(
        process.env.REACT_APP_API_URL + "/store-class",
        {
          name: newClass,
          school_id: form.school_id,
        }
      );

      const created = res.data.data;

      setClasses((prev) => [...prev, created]);

      if (Number(created.school_id) === Number(form.school_id)) {
        setFilteredClasses((prev) => [...prev, created]);
      }

      setForm((prev) => ({
        ...prev,
        class_id: created.id,
      }));

      setNewClass("");
      setShowClassModal(false);
    } catch (error) {
      if (error.response?.status === 422) {
        setClassErrors(error.response.data.errors);
      }
    }
  };

  const saveSession = async () => {

    try {
      setSessionErrors({});

      const res = await axios.post(
        process.env.REACT_APP_API_URL + "/store-session",
        newSession
      );
      const created = res.data.data;
      setSessions((prev) => [...prev, created]);
      setForm((prev) => ({
        ...prev,
        academic_session_id: created.id,
      }));

      setNewSession({
        name: "",
        start_date: "",
        end_date: ""
      });
      setShowSessionModal(false);
    } catch (error) {
      if (error.response?.status === 422) {
        setSessionErrors(error.response.data.errors);
      }
    }
  };
  const closeSessionModal = () => {
    setNewSession({
      name: "",
      start_date: "",
      end_date: ""
    });
    setSessionErrors({});
    setShowSessionModal(false);
  };
  const CHUNK_SIZE = 5 * 1024 * 1024; // 2MB

  const uploadVideoInChunks = async () => {

    if (!selectedVideo || !trainingId) {
      Swal.fire({
        title: 'Error!',
        text: 'Please select video and training.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      return;
    }

    setVideoUploading(true);

    try {
      const totalChunks = Math.ceil(
        selectedVideo.size / CHUNK_SIZE
      );

      for (
        let chunkIndex = 0;
        chunkIndex < totalChunks;
        chunkIndex++
      ) {

        const start = chunkIndex * CHUNK_SIZE;

        const end = Math.min(
          selectedVideo.size,
          start + CHUNK_SIZE
        );

        const chunk = selectedVideo.slice(
          start,
          end
        );

        const fd = new FormData();

        fd.append(
          "training_id",
          String(trainingId)
        );

        fd.append(
          "chunk_index",
          String(chunkIndex)
        );

        fd.append(
          "total_chunks",
          String(totalChunks)
        );

        fd.append(
          "file_name",
          selectedVideo.name
        );

        fd.append(
          "video_chunk",
          chunk,
          `${chunkIndex}_${selectedVideo.name}`
        );

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/school-enrollment-video-upload`,
          fd,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log(
          "Upload Response:",
          response.data
        );

        setUploadProgress(
          Math.round(
            ((chunkIndex + 1) /
              totalChunks) *
            100
          )
        );

        // 1 second delay after every chunk
        await new Promise((resolve) =>
          setTimeout(resolve, 1000)
        );
      }

      Swal.fire({
        title: 'Success!',
        text: 'Video uploaded successfully!',
        icon: 'success',
        confirmButtonText: 'Ok'
      });
      window.location.reload();
    } catch (error) {

      console.error(error);

      Swal.fire({
        title: 'Error!',
        text: 'Video upload failed.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });

    } finally {
      setVideoUploading(false);
    }
  };
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"School Enrollment"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Families"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Add New School Enrollment"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      <Card>
        <Card.Body>

          {
            !trainingId && (
              <Form onSubmit={submitForm}>
                <Row>

                  {/* Family */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Family</Form.Label>
                      <Select
                        options={familyOptions}
                        placeholder="Select Family"
                        isSearchable
                        value={familyOptions.find(
                          (option) => option.value === form.person_id
                        )}
                        onChange={(selected) => {
                          handleFamilyChange({
                            target: {
                              name: "person_id",
                              value: selected ? selected.value : "",
                            },
                          });
                        }}
                      />

                      {formErrors.person_id && (
                        <div className="text-danger mt-1">
                          {formErrors.person_id}
                        </div>
                      )}
                      <Form.Control.Feedback type="invalid">
                        {formErrors.person_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Student */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Student</Form.Label>
                      <Form.Select
                        value={form.student_id}
                        onChange={handleChildChange}
                        isInvalid={!!formErrors.student_id}
                      >
                        <option value="">Select</option>
                        {children.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.student_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Children DOB</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={form.dob}
                        onChange={handleChange}
                        isInvalid={!!formErrors.dob}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.dob}
                      </Form.Control.Feedback>
                    </Form.Group>

                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Enrollment Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="admission_date"
                        value={form.admission_date}
                        onChange={handleChange}
                        isInvalid={!!formErrors.admission_date}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.admission_date}
                      </Form.Control.Feedback>
                    </Form.Group>

                  </Col>
                  {/* Donor */}
                  {/* <Col md={6}>
                <Form.Group>
                  <Form.Label>Donor</Form.Label>
                  <Form.Select
                    name="donor_id"
                    value={form.donor_id}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {donors.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col> */}

                  {/* Institute */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>School</Form.Label>
                      <Form.Select
                        name="school_id"
                        value={form.school_id}
                        onChange={(e) =>
                          e.target.value === "__add_new__"
                            ? setShowSchoolModal(true)
                            : handleChange(e)
                        }
                        isInvalid={!!formErrors.school_id}
                      >
                        <option value="">Select</option>
                        {schools.map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.level} {i.authority}  {i.name} ({i.city_name})
                          </option>
                        ))}
                        <option value="__add_new__">+ Add New</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.school_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* Training */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Class</Form.Label>
                      <Form.Select
                        name="class_id"
                        value={form.class_id}
                        onChange={(e) =>
                          e.target.value === "__add_new__"
                            ? setShowClassModal(true)
                            : handleChange(e)
                        }
                        isInvalid={!!formErrors.class_id}
                      >
                        <option value="">Select</option>
                        {filteredClasses.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.name}
                          </option>
                        ))}
                        <option value="__add_new__">+ Add New</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.class_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Academic Session</Form.Label>
                      <Form.Select
                        name="academic_session_id"
                        value={form.academic_session_id}
                        onChange={(e) =>
                          e.target.value === "__add_new__"
                            ? setShowSessionModal(true)
                            : handleChange(e)
                        }
                        isInvalid={!!formErrors.class_id}
                      >
                        <option value="">Select</option>
                        {sessions.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.name}
                          </option>
                        ))}
                        <option value="__add_new__">+ Add New</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.class_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Roll Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="roll_no"
                        value={form.roll_no}
                        onChange={handleChange}
                        placeholder="Enter Roll Number"
                        isInvalid={!!formErrors.roll_no}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.roll_no}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={form.status}
                        onChange={(e) => handleChange(e)}
                        isInvalid={!!formErrors.status}
                      >
                        <option value="">Select</option>
                        <option value="active">active</option>
                        <option value="completed">completed</option>
                        <option value="dropped">dropped</option>
                        <option value="transferred">transferred</option>


                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formErrors.status}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Remarks</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="remarks"
                        value={form.remarks}
                        onChange={handleChange}
                        placeholder="Enter remarks..."
                        style={{ height: '45px' }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.roll_no}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* Fee */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Fee</Form.Label>
                      <Form.Control
                        type="text"
                        name="fee"
                        value={form.fee}
                        onChange={handleChange}
                        placeholder="Enter fee"
                        isInvalid={!!formErrors.fee}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.fee}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* fee_receipt */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        fee_receipt {Number(form.fee) > 0 && "*"}
                      </Form.Label>
                      <Form.Control
                        type="file"
                        id="input-fee_receipt"
                        onChange={(e) =>
                          setForm({ ...form, fee_receipt: e.target.files[0] })
                        }
                        isInvalid={!!formErrors.fee_receipt}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.fee_receipt}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* Fee */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Material Cost</Form.Label>
                      <Form.Control
                        type="text"
                        name="cost"
                        value={form.cost}
                        onChange={handleChange}
                        placeholder="Enter Cost"
                        isInvalid={!!formErrors.cost}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.cost}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* cost_receipt */}
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        cost_receipt {Number(form.cost) > 0 && "*"}
                      </Form.Label>
                      <Form.Control
                        type="file"
                        id="input-cost_receipt"
                        onChange={(e) =>
                          setForm({ ...form, cost_receipt: e.target.files[0] })
                        }
                        isInvalid={!!formErrors.cost_receipt}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.cost_receipt}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>


                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Student Picture </Form.Label>

                      <Form.Control
                        id="input-student_image"
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleImageChange(
                            e,
                            "student_image"
                          )
                        }
                      />

                      {previews.student_image && (
                        <Card className="mt-3">
                          <Card.Body className="text-center">
                            <img
                              src={previews.student_image}
                              alt="After Preview"
                              style={{
                                width: "100%",
                                maxHeight: "250px",
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                            />

                            <Button
                              variant="danger"
                              size="sm"
                              className="mt-2"
                              onClick={() =>
                                removeImage(
                                  "student_image"
                                )
                              }
                            >
                              Remove
                            </Button>
                          </Card.Body>
                        </Card>
                      )}
                    </Form.Group>
                  </Col>



                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>going to school / Institute  </Form.Label>

                      <Form.Control
                        id="input-going_image"
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleImageChange(
                            e,
                            "going_image"
                          )
                        }
                      />

                      {previews.going_image && (
                        <Card className="mt-3">
                          <Card.Body className="text-center">
                            <img
                              src={previews.going_image}
                              alt="Before Preview"
                              style={{
                                width: "100%",
                                maxHeight: "250px",
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                            />

                            <Button
                              variant="danger"
                              size="sm"
                              className="mt-2"
                              onClick={() =>
                                removeImage(
                                  "going_image"
                                )
                              }
                            >
                              Remove
                            </Button>
                          </Card.Body>
                        </Card>
                      )}
                    </Form.Group>
                  </Col>


                </Row>

                <Button type="submit" className="mt-3 float-right">
                  Save Enrollment
                </Button>
              </Form>
            )
          }
        </Card.Body>
      </Card>
      {
        trainingId && (
          <Card className="mt-4">
            <Card.Body>
              <h5>Upload Training Video</h5>

              <Form.Control
                type="file"
                accept="video/*"
                onChange={(e) =>
                  setSelectedVideo(
                    e.target.files[0]
                  )
                }
              />

              {uploadProgress > 0 && (
                <div className="progress mt-3">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${uploadProgress}%`,
                    }}
                  >
                    {uploadProgress}%
                  </div>
                </div>
              )}

              <Button
                className="mt-3"
                disabled={
                  !selectedVideo ||
                  videoUploading
                }
                onClick={
                  uploadVideoInChunks
                }
              >
                {videoUploading
                  ? "Uploading..."
                  : "Upload Video"}
              </Button>
            </Card.Body>
          </Card>
        )
      }
      {/* School Modal */}
      <AddSchoolModal
        showSchoolModal={showSchoolModal}
        closeSchoolModal={closeSchoolModal}
        setNewSchool={setNewSchool}
        setSchoolErrors={setSchoolErrors}
        newSchool={newSchool}
        schoolErrors={schoolErrors}
        cities={cities}
        saveSchool={saveSchool}
      />

      {/* Class Modal */}
      <AddClassModal
        showClassModal={showClassModal}
        setShowClassModal={setShowClassModal}
        newClass={newClass}
        classErrors={classErrors}
        setNewClass={setNewClass}
        setClassErrors={setClassErrors}
        closeClaessModal={closeClaessModal}
        saveClass={saveClass}
      />
      {/* Session Modal */}
      <AddSessionModal
        showSessionModal={showSessionModal}
        closeSessionModal={closeSessionModal}
        newSession={newSession}
        sessionErrors={sessionErrors}
        setNewSession={setNewSession}
        saveSession={saveSession}
        setSessionErrors={setSessionErrors}
      />

    </PageLayout >
  );
}